if (!customElements.get('image-compare')) {
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const imageWrapper = this.querySelector('.before-after-wrapper');
      const handle = imageWrapper.querySelector('.handle');
      const isTouch = window.matchMedia('(pointer: coarse)').matches;

      this.initDrag(handle, imageWrapper, isTouch);
    }

    initDrag(handle, imageWrapper, isTouch) {
      const getCoords = (e) => {
        const { clientX: x, clientY: y } = isTouch ? e.touches[0] : e;
        return { x, y };
      };

      const dragInit = (e) => {
        e.preventDefault();
        const { x, y } = getCoords(e);
        pos.x = x;
        pos.y = y;

        const events = isTouch ? ['ontouchmove', 'ontouchend'] : ['onmousemove', 'onmouseup'];
        document[events[0]] = elementDrag;
        document[events[1]] = closeElementDrag;
      };

      const elementDrag = (e) => {
        e.preventDefault();
        const { x, y } = getCoords(e);
        const deltaX = pos.x - x;
        pos.x = x;

        const newLeft = handle.offsetLeft - deltaX;
        if (newLeft >= 0 && newLeft <= imageWrapper.offsetWidth) {
          handle.style.left = `${newLeft}px`;
          imageWrapper.querySelector('.before-image-wrapper').style.width = `${newLeft}px`;
        }
      };

      const closeElementDrag = () => {
        const events = isTouch ? ['ontouchmove', 'ontouchend'] : ['onmousemove', 'onmouseup'];
        document[events[0]] = null;
        document[events[1]] = null;
      };

      let pos = { x: 0, y: 0 };
      handle[isTouch ? 'ontouchstart' : 'onmousedown'] = dragInit;
    }
  }

  customElements.define('image-compare', ImageCompare);
}
